import React, { useContext, useEffect, useState, useRef } from "react";
import { Controller, set, useForm } from "react-hook-form";
import { deleteMultipartFile, downloadMultipartFile, uploadMultipartFile } from "../../utility/service/api-file";
import ImagePDFComponent from "../../components/ImagePDFComponent";
import { AlertService } from "../../utility/service/alert-service";
import { getCompanySeq } from "../../utility/service/tool-service";
import PrimeDialog from "../../components/dialog/PrimeDialog";
import PrimeConfirmDialog from "../../components/dialog/PrimeConfirmDialog";
import { useTranslation } from "react-i18next";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { checkDpSuccess, getFileBase64, splitFileExtension, splitFileName } from "../../utility/service/tool-service";
import { FormInputFile } from "../../components/FormInputFile";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";
import { handleFileDownloadRes } from "../../utility/service/api-base";
import { Button } from "primereact/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { get } from "sortablejs";

const FileUploadDialog = ({
  uploadFileDialog = false,
  setUploadFileDialog,
  targeFilePath,
  targeFileCateCode,
  targeRefId,
  fileId = "",
  fileName = "",
  filePath = "",
  filePathSml = "",
  fileExtension = "",
  companySeq = getCompanySeq(),
  uploadQuery,
  deleteQuery,
}) => {
  const { t } = useTranslation();
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [, loading] = useContext(SystemLoading);

  const fileInputRef = useRef(null);
  const [hasFile, setHasFile] = useState(false);
  const [delFileDialog, setDelFileDialog] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [zoomSrc, setZoomSrc] = useState(null);
  const [fileInfo, setFileInfo] = useState({});

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    setValue,
    resetField,
    reset: resetForm,
    control,
    trigger,
    reset,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {
      keywordSearch: "",
    },
    //錯誤驗證時機
    mode: "all",
  });

  useEffect(() => {
    loadFileInfo();
    setHasFile(false);
  }, [uploadFileDialog]);

  const loadFileInfo = () => {
    if (!fileId) {
      setZoomSrc("");
      setPreviewUrl("");
      setFileInfo({});
      return;
    }

    // 設定 Zoom 圖片（原圖）
    const isPreviewable = fileExtension !== "pdf" && fileExtension !== "zip";
    setZoomSrc(isPreviewable ? filePath : "");

    // 設定預覽圖
    if (fileExtension === "pdf") {
      setPreviewUrl(filePath); // PDF 顯示原圖
    } else if (fileExtension === "zip") {
      setPreviewUrl(""); // ZIP 沒有預覽
    } else {
      setPreviewUrl(filePathSml); // 其他類型顯示縮圖
    }

    // 設定檔案資訊
    setFileInfo({
      type: fileExtension,
      name: `${fileName}.${fileExtension}`,
    });
  };

  // 每次開啟選擇檔案觸發onChange事件
  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      if (e.target.files[0].size >= 20000000) {
        AlertService.ok("Error", "Size over 20MB");
        setPreviewUrl(null);
        setZoomSrc(null);
        setValue("fileExtension", ""); //副檔名
        setValue("fileName", ""); //檔名
        setValue("filePic", "");
        setFileInfo({});
        fileInputRef.current.value = null;
      } else {
        setPreviewUrl(URL.createObjectURL(e.target.files[0]));
        setZoomSrc(URL.createObjectURL(e.target.files[0]));

        let fileExtension = splitFileExtension(e.target.files[0]?.name);
        setValue("fileExtension", fileExtension); //副檔名
        setValue("fileName", splitFileName(e.target.files[0]?.name));
        setFileInfo(e.target.files[0]);

        // 測試用 ↓
        getFileBase64(e.target.files[0]).then((result) => {
          setValue("filePathSml", result);
          setValue("filePath", result);
        });
        // 測試用 ↑
        setValue("filePic", e.target.files[0], { shouldValidate: true }); //檔案格式 原圖 如果轉為MulitPart 需解開此
        setHasFile(true);
      }
    }
  };

  // 刪除檔案
  const handleDeleteImg = () => {
    checkLoading(loading);
    deleteMultipartFile({ fileId })
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.delete") + " " + t("message.success"));
          fileInputRef.current.value = null;
          setPreviewUrl(null);
          setZoomSrc(null);
          setValue("fileExtension", ""); //副檔名
          setValue("fileName", ""); //檔名
          setValue("filePic", "");
          setUploadFileDialog(false);
          setDelFileDialog(false);
          if (deleteQuery) {
            deleteQuery();
          }
        } else {
          AlertService.ok(res?.data?.ResHeader?.rtnMsg);
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  // 上傳檔案
  const axios_uploadProvingData = () => {
    checkLoading(loading);
    const formData = new FormData();

    //call 共用上傳API API好了開啟這裡
    formData.append("fileName", getValues("fileName"));
    formData.append("filePath", targeFilePath);
    formData.append("fileCateCode", targeFileCateCode);
    formData.append("refId", targeRefId);
    formData.append("attachFile", getValues("filePic"));
    formData.append("fileExtension", getValues("fileExtension"));
    // 加上 companySeq
    formData.append("companySeq", companySeq);
    uploadMultipartFile(formData)
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.upload") + " " + t("message.success"));
          setUploadFileDialog(false);
          fileInputRef.current.value = null;
          setPreviewUrl(null);
          setZoomSrc(null);
          setValue("fileExtension", ""); //副檔名
          setValue("fileName", ""); //檔名
          setValue("filePic", "");
          if (uploadQuery) {
            uploadQuery();
          }
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  //zip 才能點下載
  const downloadItem = () => {
    checkLoading(loading);
    downloadMultipartFile({
      fileId: fileId,
    })
      .then((res) => {
        if (res?.status === 200) {
          handleFileDownloadRes(res, `${fileName}.zip`);
        } else {
          AlertService.ok(res?.data?.ResHeader?.rtnCode, res?.data?.ResHeader?.rtnMsg);
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  return (
    <>
      {/* 上傳檔案 */}
      <PrimeDialog
        visible={uploadFileDialog}
        onClose={() => {
          setUploadFileDialog(false);
          fileInputRef.current.value = null;
          setPreviewUrl(null);
          setZoomSrc(null);
          setValue("fileExtension", ""); //副檔名
          setValue("fileName", ""); //檔名
          setValue("filePic", "");
        }}
        disabledConfirm={!hasFile}
        title={t("attachments")}
        bodyTemplate={
          <div className="grid">
            <div className={` ${previewUrl || fileInfo.type === "zip" ? "col-7" : "col-12"}`}>
              <FormInputFile
                wrapperStyle={{ padding: "0.7rem" }}
                register={register}
                errors={errors}
                acceptFileType=".jpg,.png,.pdf,.zip"
                id="filePic"
                name="filePic"
                limitSize="5MB"
                fileChange={(e) => {
                  handleFileChange(e);
                }}
                rules={{
                  required: {
                    value: false,
                    message: t("validation.required"),
                  },
                }}
                fileInputRef={fileInputRef}
              />
            </div>
            {previewUrl && (
              <div className={`${previewUrl ? "col-5" : ""}`}>
                <ImagePDFComponent
                  wrapperClass=""
                  file={fileInfo}
                  previewUrl={previewUrl}
                  zoomSrc={zoomSrc}
                  imgWidth="140"
                  imgHeight="140"
                  deleteImg={() => {
                    if (fileId) {
                      setDelFileDialog(true);
                    }
                  }}
                />
              </div>
            )}

            {fileInfo.type === "zip" && (
              <div className="flex flex-wrap lg:flex-nowrap align-items-center">
                <label>
                  {fileName}
                  {fileName !== "" ? "." : ""}
                  {fileExtension}
                </label>
                <Button
                  type="button"
                  icon="pi pi-trash"
                  tooltip={t("button.delete")}
                  tooltipOptions={{ position: "top" }}
                  className="p-button-icon-only"
                  rounded
                  text
                  severity="danger"
                  onClick={(e) => {
                    handleDeleteImg();
                  }}
                ></Button>

                <Button
                  rounded
                  text
                  severity="secondary"
                  className="p-button-icon-only"
                  type="button"
                  tooltip={t("button.download")}
                  tooltipOptions={{ position: "top" }}
                  onClick={() => {
                    downloadItem();
                  }}
                >
                  <FontAwesomeIcon icon="fa-solid fa-cloud-arrow-down" />
                </Button>
              </div>
            )}
          </div>
        }
        onConfirm={() => {
          axios_uploadProvingData();
        }}
      />

      {/* 刪除檔案 */}
      <PrimeConfirmDialog
        visible={delFileDialog}
        onClose={() => {
          setDelFileDialog(false);
        }}
        onConfirm={() => {
          handleDeleteImg();
        }}
        title={t("button.delete")}
        bodyTemplate={<div className="form-label">{t("conf_del", { name: fileName })}</div>}
      />
    </>
  );
};

export default FileUploadDialog;
